(function () {
  if (!document.body || !document.body.classList.contains('modello-rosanostra')) {
    return;
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    return;
  }

  var lastPetalAt = 0;

  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  function dropPetal(event) {
    var now = Date.now();
    if (now - lastPetalAt < 160) {
      return;
    }
    lastPetalAt = now;

    var petal = document.createElement('span');
    var startX = event.clientX + randomBetween(-18, 18);
    var drift = randomBetween(-110, 110);
    var size = randomBetween(13, 22);
    var duration = randomBetween(7.8, 11.5);

    petal.className = 'rosanostra-petal';
    petal.setAttribute('aria-hidden', 'true');
    petal.style.setProperty('--petal-x', startX + 'px');
    petal.style.setProperty('--petal-drift', drift + 'px');
    petal.style.setProperty('--petal-size', size + 'px');
    petal.style.setProperty('--petal-duration', duration + 's');

    document.body.appendChild(petal);

    window.setTimeout(function () {
      petal.remove();
    }, Math.ceil(duration * 1000) + 300);
  }

  document.addEventListener('click', dropPetal, { passive: true });
})();
